import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { withStyles } from 'tss-react/mui';

const StyledTooltip = withStyles(Tooltip, () => ({
    tooltip: {
        color: '#FFFFFF',
        fontSize: 12,
        backgroundColor: '#3E536E',
    },
    arrow: {
        color: '#3E536E',
    },
}));

const PageNavTooltip = ({ title, children }: { title: string; children: React.ReactNode }) => (
    <StyledTooltip title={title} arrow placement="right">
        <div>{children}</div>
    </StyledTooltip>
);

export default PageNavTooltip;
